import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  {
    title: 'Transaction ID',
    prop: 'id'
  },
  {
    title: 'Account Name',
    prop: 'account_id',
    references: 'admin/accounts',
    referenceProp: 'account_name'
  },
  {
    title: 'Type',
    prop: 'transaction_type'
  },
  {
    title: 'Amount',
    prop: 'amount',
    format: 'currency'
  },
  {
    title: 'Date Created',
    prop: 'created_at',
    format: 'date'
  }
]

const filters = [{
  name: 'Status',
  prop: 'filters.transaction_status',
  type: 'multipleSelect',
  enabled: true,
  items: [{ prop: 'void', title: 'Void' }, { prop: 'valid', title: 'Valid' }]
}, {
  name: 'Date greater than',
  prop: 'filters.transaction_date_gte',
  type: 'datepicker',
  enabled: true
}, {
  name: 'Date less than',
  prop: 'filters.transaction_date_lte',
  type: 'datepicker',
  enabled: true
}, {
  name: 'Filter by product code',
  prop: 'filters.product_id',
  type: 'autocomplete',
  references: 'admin/products',
  displayProp: 'code',
  referenceProp: 'fullname',
  enabled: true
}, {
  name: 'Amount greater than',
  prop: 'filters.amount_gte',
  type: 'text',
  enabled: true
}, {
  name: 'Amount less than',
  prop: 'filters.amount_lte',
  type: 'text',
  enabled: true
}, {
  name: 'Filter by invoice id',
  prop: 'filters.invoice_id',
  type: 'text',
  enabled: true
}, {
  name: 'Filter by order id',
  prop: 'filters.order_id',
  type: 'text',
  enabled: true
}, {
  name: 'Search by user name',
  prop: 'filters.user_name_ilike',
  type: 'text',
  enabled: true
}, {
  name: 'Search by institution name',
  prop: 'filters.institution_name_ilike',
  type: 'text',
  enabled: true
}]

const defaults = {
  order: [{ column: 'id', direction: 'desc' }]
}

const TransactionList = (props) => (
  <List
    title='Transactions'
    apiPath='admin/transactions'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    withExport
    hideCreate
  />
)

export default TransactionList
